import { isSettingLocked } from "../../../erd-editor-schema/dist/v3/schema/settings.js";
import { LockSettingType } from "../../../constants/schema.js";
import { Tag } from "../../tag.js";
import { bHas } from "../../../utils/bit.js";
import { CodeSettingLocks } from "./actions.js";
import { isNil, pick } from "es-toolkit";
//#region src/engine/modules/settings/screenBaseline.ts
var VIEWPORT_FIELDS = [
	"originX",
	"originY",
	"zoomLevel"
];
var isScreenWrite = (tags) => !isNil(tags) && bHas(tags, Tag.screen);
var isRemoteWrite = (tags) => !isNil(tags) && (bHas(tags, Tag.shared) || bHas(tags, Tag.following));
var hasScreenBaseline = (editor, unit) => !isNil(editor.screenBaseline?.[unit]);
function keepScreenBaseline(state, unit) {
	const { editor, settings } = state;
	if (hasScreenBaseline(editor, unit)) return;
	if (!editor.screenBaseline) editor.screenBaseline = {};
	const baseline = editor.screenBaseline;
	if (unit === "viewport") baseline.viewport = pick(settings, VIEWPORT_FIELDS);
	else holdSetting(baseline, settings, unit);
}
function endScreenBaseline(editor, ...units) {
	const baseline = editor.screenBaseline;
	if (!baseline) return;
	units.forEach((unit) => Reflect.deleteProperty(baseline, unit));
	if (Object.keys(baseline).length === 0) editor.screenBaseline = null;
}
function holdSetting(target, source, unit) {
	target[unit] = source[unit];
}
function settingWriteTarget(state, tags, unit) {
	const { editor, settings } = state;
	if (isScreenWrite(tags)) keepScreenBaseline(state, unit);
	else if (!isRemoteWrite(tags)) endScreenBaseline(editor, unit);
	else if (editor.screenBaseline && hasScreenBaseline(editor, unit)) return editor.screenBaseline;
	return settings;
}
function viewportWriteTarget(state, tags) {
	const { editor, settings } = state;
	if (isScreenWrite(tags)) keepScreenBaseline(state, "viewport");
	else if (!isRemoteWrite(tags)) endScreenBaseline(editor, "viewport");
	return isRemoteWrite(tags) && editor.screenBaseline?.viewport || settings;
}
var UNIT_LOCKS = {
	canvasType: LockSettingType.canvasType,
	nameViewMode: LockSettingType.unlockNameViewMode,
	...CodeSettingLocks
};
var LOAD_HELD_UNITS = [
	"canvasType",
	"show",
	"database",
	"language",
	"tableNameCase",
	"columnNameCase",
	"bracketType"
];
var isUnitLocked = (settings, unit) => {
	const lock = UNIT_LOCKS[unit];
	return !isNil(lock) && isSettingLocked(settings.lockSettings, lock);
};
function landScreenBaseline(state, screen, tags) {
	const { editor, settings } = state;
	const baseline = editor.screenBaseline;
	if (!baseline) return;
	const ended = ["viewport"];
	if (!isUnitLocked(settings, "nameViewMode")) ended.push("nameViewMode");
	LOAD_HELD_UNITS.forEach((unit) => {
		if (!hasScreenBaseline(editor, unit) || isUnitLocked(settings, unit)) return;
		if (isRemoteWrite(tags)) {
			holdSetting(baseline, settings, unit);
			holdSetting(settings, screen, unit);
		} else ended.push(unit);
	});
	endScreenBaseline(editor, ...ended);
}
//#endregion
export { endScreenBaseline, isRemoteWrite, isScreenWrite, keepScreenBaseline, landScreenBaseline, settingWriteTarget, viewportWriteTarget };
